import { NavLink } from 'react-router-dom';
import { useAdminUser } from '../AdminUserContext';

export default function AdminLayout({ children }) {
  const { user } = useAdminUser();
  const isAdmin = user?.role === 'admin' || user?.role === undefined;

  const logout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    window.location.href = '/admin/login';
  };

  return (
    <div className="admin-root light">
      <div className="admin-shell">
        <aside className="admin-sidebar">
          <div className="admin-sidebar-logo">
            <img src="/images/logo-site.png" alt="logo" />
            <span>لوحة التحكم</span>
          </div>

          <nav className="admin-nav">
            <NavLink to="/admin/dashboard" end>
              <i className="fas fa-chart-bar" /> Dashboard
            </NavLink>
            {isAdmin && (
              <NavLink to="/admin/stream">
                <i className="fas fa-satellite-dish" /> Live Stream
              </NavLink>
            )}
            {isAdmin && (
              <NavLink to="/admin/languages">
                <i className="fas fa-language" /> Languages
              </NavLink>
            )}
            <NavLink to="/admin/audio">
              <i className="fas fa-music" /> Audio Control
            </NavLink>
            {isAdmin && (
              <NavLink to="/admin/users">
                <i className="fas fa-users-cog" /> Admin Users
              </NavLink>
            )}
          </nav>

          <div className="admin-sidebar-footer">
            {user?.username && (
              <div style={{ fontSize: 12, color: 'var(--a-muted)', marginBottom: 10, padding: '0 4px' }}>
                <i className="fas fa-user" style={{ marginInlineEnd: 6 }} />
                {user.username}
                {user.role && (
                  <span style={{ marginInlineStart: 6, background: user.role === 'admin' ? 'var(--a-gold2)' : 'rgba(100,100,100,.3)', color: user.role === 'admin' ? 'var(--a-gold)' : 'var(--a-muted)', borderRadius: 4, padding: '1px 6px', fontSize: 10, textTransform: 'uppercase' }}>
                    {user.role}
                  </span>
                )}
              </div>
            )}
            <button className="a-logout-btn" onClick={logout}>
              <i className="fas fa-sign-out-alt" /> Logout
            </button>
          </div>
        </aside>

        <main className="admin-content">{children}</main>
      </div>
    </div>
  );
}
